(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["recipe-featured-product"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
  const productForms = document.querySelectorAll('.featured-product .product-form');
  
  productForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      
      const formData = new FormData(form);
      const button = form.querySelector('button[type="submit"]');
      const originalText = button.textContent;
      
      button.disabled = true;
      button.textContent = 'AÑADIENDO...';
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        button.textContent = '¡AÑADIDO!';
        setTimeout(() => {
          button.disabled = false;
          button.textContent = originalText;
        }, 2000);
      })
      .catch(error => {
        console.error('Error:', error);
        button.disabled = false;
        button.textContent = originalText;
      });
    });
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const btn = document.activeElement;
    if (!btn || !btn.classList.contains('load-video-button')) return;

    // Hide play button from AT and tab order after activation
    btn.setAttribute('aria-hidden', 'true');
    btn.setAttribute('tabindex', '-1');

    // Shift focus to the video-interaction-hint (play/pause toggle) inside
    // the same deferred-media container once the video has been injected
    const media = btn.closest('deferred-media');
    if (!media) return;

    requestAnimationFrame(function () {
      const hint = media.querySelector('.video-interaction-hint');
      if (!hint) return;
      hint.classList.remove('hidden');
      hint.removeAttribute('hidden');
      hint.setAttribute('tabindex', '0');
      hint.focus();
    });
  });

  // Shopify's video_tag generates an <img> fallback inside <video> without alt.
  // Set alt="" on all such images so screen readers skip them (they are decorative).
  function setVideoFallbackAlt() {
    document.querySelectorAll('video img:not([alt])').forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setVideoFallbackAlt);
  } else {
    setVideoFallbackAlt();
  }

  // Also handle videos injected after page load (deferred-media / lazy sections)
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        node.querySelectorAll
          ? node.querySelectorAll('video img:not([alt])').forEach(function (img) {
              img.setAttribute('alt', '');
            })
          : null;
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
  } catch(e) { console.error(e); }
})();

})();
